<template>
  <div class="form_item">
    <div>
      <Label :required="required" :label="label" :name="save_to"/>
      <masked-input
        :name="validationLabel || label"
        :key="save_to"
        :required="required"
        :id="save_to"
        type="text"
        :guide="false"
        v-model="val"
        :mask="mask"
        :placeholder="placeholder"
        @blur.native="onBlur()"
        @change.native="onChange()"
        @input.native="val=$event.target.value.toUpperCase()"
        v-validate="rules"
      />
    </div>
    <p v-if="info !== undefined" class="info" v-html="info"></p>
    <span class="error" v-show="errors.has(validationLabel || label)">{{ errors.first(validationLabel || label) }}</span>
  </div>
</template>

<script>
import MaskedInput from 'vue-text-mask';
import { validatorComponent } from './validatorComponentMixin';
import { customBlurMixin } from './customBlurMixin';



export default {
  name: 'Iban',
  components: { MaskedInput },
  mixins: [validatorComponent, customBlurMixin],
  props: {
    save_to: String,
    placeholder: String,
    required: Boolean,
    unique: Boolean,
    validationLabel: String,
    operationId: String,
    acceptedCountries: Array,
    _id : String,
    testmode: {
      type: Object,
    },
  },
  methods: {
    mask: function (rawValue) {
      const n = Math.min(rawValue.replace(/[ _]/g, '').length, 34);

      return new Array(Math.floor(n / 4 + 1) * 5).fill().map((c, i) => (i + 1) % 5 === 0 ? ' ' : /[\da-zA-Z]/);
    }
  },
  computed: {
    rules() {
      let unique = false;
      if(this.unique && !(this.testmode && this.testmode.active && this.testmode.disableunique)) {
        unique = ['iban', this.operationId]
      }
      const acceptedCountries = this.acceptedCountries;
      const ibanValidation = {
        acceptedCountries: (acceptedCountries && acceptedCountries.length > 0)?acceptedCountries:[]
      }
      return {
        required: this.required,
        iban: true,
        countryiban: ibanValidation,
        unique
      }
    }
  }
};
</script>
